const isCampaignPopUpsEnabled = (): boolean =>
  process.env.REACT_APP_CAMPAIGN_POP_UPS_ENABLED === 'true'

const isCampaignEmailEnabled = (): boolean =>
  process.env.REACT_APP_CAMPAIGN_EMAIL_ENABLED === 'true'

const getCampaignDialogTabs = (activeReward: boolean): string[] => {
  const tabs = activeReward
    ? ['Campaña', 'Segmentar', 'Beneficio', 'Horarios', 'Push']
    : ['Campaña', 'Segmentar', 'Beneficio', 'Push']

  if (isCampaignPopUpsEnabled()) {
    tabs.push('Pop-up')
  }
  if (isCampaignEmailEnabled()) {
    tabs.push('Email')
  }

  return tabs
}

const getCampaignPopUpTabIndex = (activeReward: boolean): number => (activeReward ? 5 : 4)

const getCampaignEmailTabIndex = (activeReward: boolean): number =>
  isCampaignPopUpsEnabled()
    ? getCampaignPopUpTabIndex(activeReward) + 1
    : getCampaignPopUpTabIndex(activeReward)

const shouldShowPushImageUpload = (): boolean => !isCampaignPopUpsEnabled()

const getVoucherDialogTabs = (): string[] => {
  const tabs = ['Voucher', 'Segmentar', 'Beneficio', 'Push']
  if (isCampaignPopUpsEnabled()) {
    tabs.push('Pop-up')
  }
  return tabs
}

const getVoucherPopUpTabIndex = (): number => 4

export {
  isCampaignPopUpsEnabled,
  isCampaignEmailEnabled,
  getCampaignDialogTabs,
  getCampaignPopUpTabIndex,
  getCampaignEmailTabIndex,
  shouldShowPushImageUpload,
  getVoucherDialogTabs,
  getVoucherPopUpTabIndex,
}
